import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getCompanies, updateCompany } from "@/services/adminApi";

export function useCompanies(limit = 50) {
  return useQuery({
    queryKey: ["admin", "companies", limit],
    queryFn: () => getCompanies(limit),
  });
}

export function useUpdateCompany() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      updates,
    }: {
      id: string;
      updates: { name?: string; country?: string; status?: string };
    }) => updateCompany(id, updates),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin", "companies"] });
    },
  });
}
